let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("keKRT")).then(() => parcelRequire('hTMhc'));